import type { Notebook } from './types';

/** Mirrors the API's `DEFAULT_NOTEBOOK_TITLE`: the title it gives the auto-created notebook that adopts old documents. */
export const DEFAULT_NOTEBOOK_TITLE = 'My documents';

/**
 * The API stores the default notebook's title in English, so the web swaps in the
 * localised label — but only while the title is still the stored default. A renamed
 * default notebook, or a regular notebook that happens to share the name, shows as stored.
 */
export function getNotebookTitle(notebook: Pick<Notebook, 'title' | 'isDefault'>, defaultLabel: string): string {
  return notebook.isDefault && notebook.title === DEFAULT_NOTEBOOK_TITLE ? defaultLabel : notebook.title;
}
